import {Component, Injectable, OnInit} from '@angular/core';
import {MachineGroup} from "../../model/machine-group";
import {MachineGroupsService} from "../../services/machine-groups.service";
import {CommonMessagesService} from "../../services/common-messages.service";
import {MachineGroupFilters} from "../../model/filters/machine-group-filters";
import {LoggedUser} from "../../common/logged-user.service";
import {MachinesService} from "../../services/machines.service";
import {Machine} from "../../model/machine";
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'app-groups-list',
  templateUrl: './machine-groups-list.component.html',
  styleUrls: ['./machine-groups-list.component.scss']
})
@Injectable({
  providedIn: 'root'
})
export class MachineGroupsListComponent implements OnInit {

  public groups: MachineGroup[];
  public totalGroups: number;
  public loadingGroups: boolean;

  public machines: Machine[];

  public rows: number = 10;
  public first: number = 0;

  public filtersVisible: boolean;
  public currentFilters: MachineGroupFilters;
  public language: string;


  constructor(private machineGroupsService: MachineGroupsService,
              private machinesService: MachinesService,
              private loggedUser: LoggedUser,
              private commonMessagesService: CommonMessagesService,
              private readonly i18n: TranslocoService) {
    this.currentFilters = new MachineGroupFilters();
  }

  ngOnInit(): void {
    this.language = this.i18n.getActiveLang();
    this.groups = new Array(this.rows);
    this.loadFilters();
  }

  confirmAndDelete(machineGroup: MachineGroup): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.deleteGroup(machineGroup.machineGroupUuid);
    });
  }

  deleteGroup(machineGroupUuid: string): void {
    this.machineGroupsService.deleteGroup(machineGroupUuid).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadGroups(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  loadGroups(offset?: number, limit?: number): void {
    this.loadingGroups = true;
    this.groups = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    this.loggedUser.userObservable.subscribe(() => {
      this.machineGroupsService.getGroups(offset, limit, this.currentFilters).subscribe(response => {
        this.groups = response.data.content;
        this.totalGroups = response.data.totalElements;
        this.loadingGroups = false;
      });
    });
  }

  trimFieldsForm(filters: MachineGroupFilters): void {
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

  onPageChange(event): void {
    this.loadGroups(event.first / event.rows, event.rows);
  }

  private loadFilters(): void {
    this.machinesService.getMachinesMinSummary().subscribe(response => {
      this.machines = response.machines;
    });
  }

  resetFilters(): void {
    this.currentFilters = new MachineGroupFilters();
  }

  applyFilters(): void {
    this.first = 0;
    this.loadGroups(this.first / this.rows, this.rows);
  }

}
